import { useTranslation } from "react-i18next";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Grid from "@material-ui/core/Grid";
import TextField from "../TextField";
import Select from "../Select";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Button from "../Button";

const TEMPLATE_TYPE_OPTIONS = [
  { value: "nudge", label: "Nudge" },
  { value: "evaluation", label: "Evaluation" },
  { value: "summarization", label: "Summarization" },
  { value: "custom", label: "Custom" },
];

const validationSchema = Yup.object({
  name: Yup.string()
    .max(255, "Name must be at most 255 characters")
    .required("Name is required"),
  template_type: Yup.string()
    .oneOf(["nudge", "evaluation", "summarization", "custom"], "Invalid template type")
    .required("Template type is required"),
  prompt_content: Yup.string()
    .required("Prompt content is required"),
  description: Yup.string()
    .max(500, "Description must be at most 500 characters"),
});

export default function PromptTemplateForm({ initialValues, onSubmit, isLoading, onCancel }) {
  const { t } = useTranslation();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ values, errors, touched, handleChange, handleBlur, setFieldValue }) => (
        <Form>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <TextField
                name="name"
                label={t("promptTemplate.name") || "Name"}
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name && errors.name}
                fullWidth
                required
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Select
                list={TEMPLATE_TYPE_OPTIONS}
                name="template_type"
                value={values.template_type}
                onChange={e => setFieldValue("template_type", e.target.value)}
                placeholder={t("promptTemplate.selectType") || "Select Type"}
                error={touched.template_type && Boolean(errors.template_type)}
                helperText={touched.template_type && errors.template_type}
                fullWidth
                required
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                name="prompt_content"
                label={t("promptTemplate.promptContent") || "Prompt Content"}
                value={values.prompt_content}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.prompt_content && Boolean(errors.prompt_content)}
                helperText={touched.prompt_content && errors.prompt_content}
                fullWidth
                multiline
                rows={8}
                required
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                name="description"
                label={t("promptTemplate.description") || "Description"}
                value={values.description}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.description && Boolean(errors.description)}
                helperText={touched.description && errors.description}
                fullWidth
                multiline
                rows={3}
              />
            </Grid>

            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={values.is_active === 1}
                    onChange={e => setFieldValue("is_active", e.target.checked ? 1 : 0)}
                    color="primary"
                  />
                }
                label={values.is_active === 1 ? "Active" : "Inactive"}
              />
            </Grid>

            <Grid item xs={12}>
              <div style={{ display: "flex", gap: "8px" }}>
                <Button type="submit" disabled={isLoading}>
                  {t("common.save") || "Save"}
                </Button>
                <Button variant="outlined" onClick={onCancel}>
                  {t("common.cancel") || "Cancel"}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
}